// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"bfac3b0d","990":"24e6fd7f"}[chunkId] + ".chunk.css";
};